// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLoggedInState } from '../../../context/LoggedInContext';
import { Grid, IconButton, Menu, MenuItem } from '../../../lib/base';
import { MenuIcon } from '../../../lib/icons';
import { AccountOrLoginButton } from '../../login';
import { AppBarShell } from './AppBarShell';
import { getButtons } from './AppBarUpMD';
import { TitleLink } from './TitleLink';

export const AppBarDownMD = () => {
  const { isLoggedIn } = useLoggedInState();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuItemKeyDown = (event: React.KeyboardEvent, href: string) => {
    if (event.key === 'Enter' || event.key === ' ') {
      navigate(href);
      handleClose();
    }
  };

  const location = useLocation();

  return (
    <AppBarShell>
      <Grid container flexWrap="nowrap" display="flex" alignItems="center" justifyContent="space-between">
        <Grid sx={{ width: '75px' }}>
          <IconButton aria-label="menu-button" sx={{ p: 0, color: 'primary.contrastText' }} onClick={handleClick}>
            <MenuIcon fontSize="large" />
          </IconButton>
        </Grid>
        <Grid sx={{ flex: '1 1 auto', maxWidth: '150px' }} />
        <Grid sx={{ width: '290px' }}>
          <TitleLink />
        </Grid>
        <Grid sx={{ flex: '1 1 auto', maxWidth: '150px' }} />
        <Grid sx={{ flex: '0 1 auto', width: '75px' }}>
          <AccountOrLoginButton />
        </Grid>
      </Grid>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {getButtons(location).map((button) => {
          const child = (
            <MenuItem
              key={button.id}
              onClick={(e) => {
                handleClose();
                navigate(button.href);
              }}
              onKeyDown={(e) => handleMenuItemKeyDown(e, button.href)}
              selected={button.selected}
            >
              {button.label}
            </MenuItem>
          );
          return button.requireSignIn ? (isLoggedIn ? child : null) : child;
        })}
      </Menu>
    </AppBarShell>
  );
};
